import { Routes, Route, Navigate } from 'react-router-dom';
import { SignedIn, SignedOut, SignIn, SignUp } from '@clerk/clerk-react';
import AuthPageShell from './components/AuthPageShell';
import Layout from './components/Layout';
import Status from './pages/Status';
import Dashboards from './pages/Dashboards';
import Settings from './pages/Settings';
import CallHistory from './pages/CallHistory';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  return (
    <>
      <SignedIn>{children}</SignedIn>
      <SignedOut>
        <Navigate to="/sign-in" replace />
      </SignedOut>
    </>
  );
}

export default function App() {
  return (
    <Routes>
      <Route
        path="/sign-in/*"
        element={
          <AuthPageShell>
            <SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" />
          </AuthPageShell>
        }
      />
      <Route
        path="/sign-up/*"
        element={
          <AuthPageShell>
            <SignUp routing="path" path="/sign-up" signInUrl="/sign-in" />
          </AuthPageShell>
        }
      />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <Layout>
              <Routes>
                <Route index element={<Status />} />
                <Route path="dashboards" element={<Dashboards />} />
                <Route path="settings/*" element={<Settings />} />
                <Route path="call-history" element={<CallHistory />} />
              </Routes>
            </Layout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}
